import React from "react";

export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-check-circle"
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
    </svg>
  );
};

export const PassKeyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-key"
      viewBox="0 0 16 16"
    >
      <path d="M0 8a4 4 0 0 1 7.465-2H14a.5.5 0 0 1 .354.146l1.5 1.5a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0L13 9.207l-.646.647a.5.5 0 0 1-.708 0L11 9.207l-.646.647a.5.5 0 0 1-.708 0L9 9.207l-.646.647A.5.5 0 0 1 8 10h-.535A4 4 0 0 1 0 8m4-3a3 3 0 1 0 2.712 4.285A.5.5 0 0 1 7.163 9h.63l.853-.854a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.793-.793-1-1h-6.63a.5.5 0 0 1-.451-.285A3 3 0 0 0 4 5" />
      <path d="M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
  );
};

export const PasswordKeyIcon = () => {
  return (
    <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7321 7.00023C12.2626 7.91897 13.1362 8.58932 14.1609 8.86389C15.1857 9.13846 16.2775 8.99477 17.1962 8.46434C18.115 7.9339 18.7854 7.06018 19.0599 6.03546C19.3345 5.01074 19.1908 3.91897 18.6604 3.00023C18.1299 2.0815 17.2563 1.41115 16.2316 1.13658C15.2068 0.862007 14.115 1.0057 13.1962 1.53613C12.2775 2.06657 11.6071 2.94029 11.3326 3.96501C11.058 4.98973 11.2017 6.0815 11.7321 7.00023ZM11.7321 7.00023L1.33984 13.0002L2.83984 15.5983M4.80395 11.0002L5.80395 12.7323"
        stroke="#303A47"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></path>
    </svg>
  );
};
export const LockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      stroke="#FFF"
      className="bi bi-lock"
      viewBox="0 0 16 16"
    >
      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
    </svg>
  );
};

export const HomeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31.803" height="30.402" viewBox="0 0 31.803 30.402">
      <g id="Group_4132" data-name="Group 4132" transform="translate(-19.919 -27.75)">
        <path
          id="Path_15199"
          data-name="Path 15199"
          d="M21.982,41.613a1.139,1.139,0,0,1-1.838-.432,1.651,1.651,0,0,1,.432-2.162L35.169,27.993a1.137,1.137,0,0,1,1.405,0L51.168,39.019a1.762,1.762,0,0,1,.324,2.162,1.139,1.139,0,0,1-1.838.432L35.818,31.128Z"
          fill="#333"
        />
        <path
          id="Path_15200"
          data-name="Path 15200"
          d="M78.43,88.188v13.62a2.052,2.052,0,0,1-2.054,2.054H70.647V93.485a1.822,1.822,0,0,0-1.838-1.838H63.729a1.759,1.759,0,0,0-1.838,1.838v10.377H56.054A2.126,2.126,0,0,1,54,101.809V88.188L66.215,79Z"
          transform="translate(-30.397 -45.71)"
          fill="#333"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const UsersIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="34.453" height="30.275" viewBox="0 0 34.453 30.275">
      <g id="Group_4192" data-name="Group 4192" transform="translate(-111.112 -103.449)">
        <path
          id="Path_15231"
          data-name="Path 15231"
          d="M193.58,176.694c-3.448,1.483-4.941,4.322-5.084,8.089-.04,1.072-.035,1.03-1.077.95a35.094,35.094,0,0,1-5.47-1.108,1.026,1.026,0,0,1-.9-1.253c.058-.752.013-1.569.013-2.506a12.475,12.475,0,0,1,.4-4.345,6.411,6.411,0,0,1,5.873-4.428c1.366-.1,2.741,0,4.112-.025.421,0,.674.11.752.6a6.7,6.7,0,0,0,1.5,3.508C193.936,176.446,193.881,176.567,193.58,176.694Z"
          transform="translate(-69.93 -57.674)"
          fill="#333"
        />
        <path
          id="Path_15232"
          data-name="Path 15232"
          d="M204.824,134.5a4.45,4.45,0,0,0-1.5,2.506c-.251,1.326-1.113,1.634-2.127,1.847a3.6,3.6,0,0,1-.674.055,5.065,5.065,0,0,1-5.084-4.7,5.2,5.2,0,0,1,3.621-5.475,4.843,4.843,0,0,1,5.956,3.187c.113.331.173.684.283,1A1.376,1.376,0,0,1,204.824,134.5Z"
          transform="translate(-80.692 -25.081)"
          fill="#333"
        />
        <path
          id="Path_15233"
          data-name="Path 15233"
          d="M272.909,137.55a4.851,4.851,0,0,1-3.443,1.29c-.188-.023-.546-.068-.9-.118a1.245,1.245,0,0,1-1.138-1.12,6.142,6.142,0,0,0-2.2-3.633,1.224,1.224,0,0,1-.466-1.388,5.112,5.112,0,0,1,4.393-4.1,4.982,4.982,0,0,1,5.087,3.22A5.357,5.357,0,0,1,272.909,137.55Z"
          transform="translate(-132.633 -25)"
          fill="#333"
        />
        <path
          id="Path_15234"
          data-name="Path 15234"
          d="M241.122,155.726a5.173,5.173,0,0,1-4.974,5.262,5.041,5.041,0,0,1-4.909-5.262,4.885,4.885,0,0,1,4.911-5.107A5,5,0,0,1,241.122,155.726Z"
          transform="translate(-107.549 -41.615)"
          fill="#333"
        />
        <path
          id="Path_15235"
          data-name="Path 15235"
          d="M282.09,183.544a.959.959,0,0,1-.644,1.06,18.427,18.427,0,0,1-5.583,1.268c-.616.043-.752-.281-.729-.837a9.139,9.139,0,0,0-1.253-5.027,7.813,7.813,0,0,0-3.531-3.175c-.426-.2-.616-.313-.251-.774a7.266,7.266,0,0,0,1.371-3.318c.05-.308.133-.619.5-.609,1.827.053,3.673-.251,5.475.308a6.642,6.642,0,0,1,4.636,6.309c.018.784,0,1.569,0,2.353h0C282.08,181.916,282.053,182.73,282.09,183.544Z"
          transform="translate(-136.527 -57.711)"
          fill="#333"
        />
        <path
          id="Path_15236"
          data-name="Path 15236"
          d="M233.927,205.659a.869.869,0,0,1-.584.92,17.669,17.669,0,0,1-6.119,1.331,27.052,27.052,0,0,1-9.65-1.3.9.9,0,0,1-.714-1.047c.03-.867,0-1.736,0-2.6h0c0-.814-.023-1.629,0-2.438a6.464,6.464,0,0,1,6.162-6.367c1.451-.033,2.9-.018,4.35,0a6.542,6.542,0,0,1,6.515,6.63C233.952,202.4,233.9,204.03,233.927,205.659Z"
          transform="translate(-96.765 -74.225)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const CalenderIcon = () => {
  return (
    <svg
      id="Group_4190"
      data-name="Group 4190"
      xmlns="http://www.w3.org/2000/svg"
      width="28.536"
      height="30.215"
      viewBox="0 0 28.536 30.215"
    >
      <g id="Group_4190-2" data-name="Group 4190">
        <path
          id="Path_15256"
          data-name="Path 15256"
          d="M142.287,3.845V.817a.815.815,0,1,0-1.631,0V3.845Z"
          transform="translate(-132.414)"
          fill="#333"
        />
        <path
          id="Path_15257"
          data-name="Path 15257"
          d="M326.778,3.845V.817a.815.815,0,1,0-1.631,0V3.845Z"
          transform="translate(-304.994)"
          fill="#333"
        />
        <path
          id="Path_15258"
          data-name="Path 15258"
          d="M234.532,3.845V.817a.815.815,0,1,0-1.631,0V3.845Z"
          transform="translate(-218.704)"
          fill="#333"
        />
        <path
          id="Path_15259"
          data-name="Path 15259"
          d="M50.043,3.845V.817a.815.815,0,1,0-1.631,0V3.845Z"
          transform="translate(-46.126)"
          fill="#333"
        />
        <path
          id="Path_15260"
          data-name="Path 15260"
          d="M36.118,59.452H13.951A.952.952,0,0,0,13,60.4v3.32H37.07V60.4A.952.952,0,0,0,36.118,59.452ZM16.917,60.7a.815.815,0,1,1-1.631,0v-1.14h1.631V60.7Zm5.955,0a.815.815,0,1,1-1.631,0v-1.14h1.631V60.7Zm5.955,0a.815.815,0,1,1-1.631,0v-1.14h1.631V60.7Zm5.955,0a.815.815,0,1,1-1.631,0v-1.14h1.631V60.7Z"
          transform="translate(-13 -55.614)"
          fill="#333"
        />
      </g>
      <g id="Group_4191" data-name="Group 4191" transform="translate(0 9.744)">
        <path
          id="Path_15261"
          data-name="Path 15261"
          d="M13,150.924v15.044a.952.952,0,0,0,.951.953h12.66a8.479,8.479,0,0,1,.915-6.764h-.284a.834.834,0,0,1-.842-.8.816.816,0,0,1,.815-.832H28.24a.81.81,0,0,1,.452.137,8.438,8.438,0,0,1,8.378-2.216v-5.522H13Zm8.83,3.471h1.026a.817.817,0,0,1,0,1.633H21.83a.817.817,0,0,1,0-1.633Zm-4.359,9.892H16.445a.817.817,0,0,1,0-1.633h1.026a.817.817,0,0,1,0,1.633Zm0-4.13H16.445a.817.817,0,0,1,0-1.633h1.026a.817.817,0,0,1,0,1.633Zm5.385,4.13H21.83a.817.817,0,0,1,0-1.633h1.026a.817.817,0,0,1,0,1.633Zm-.513-3.639a1.377,1.377,0,1,1,1.374-1.377A1.375,1.375,0,0,1,22.343,160.649Zm5.9-4.621H27.214a.817.817,0,0,1,0-1.633H28.24a.817.817,0,0,1,0,1.633Zm5.385,0H32.6a.817.817,0,0,1,0-1.633h1.026a.817.817,0,0,1,0,1.633Z"
          transform="translate(-13 -150.924)"
          fill="#333"
        />
        <path
          id="Path_15262"
          data-name="Path 15262"
          d="M250.78,256.632a6.823,6.823,0,1,0,6.812,6.823A6.825,6.825,0,0,0,250.78,256.632Zm-4.669,7a4.8,4.8,0,0,1,4.7-4.891,4.542,4.542,0,0,1,.535.032.815.815,0,0,1,1.52-.576l.774,1.654a.826.826,0,0,1-.433,1.1l-1.378.574a.83.83,0,0,1-1.066-.441.816.816,0,0,1,.044-.715,3.171,3.171,0,0,0-3.064,3.257.815.815,0,1,1-1.631,0Zm9.326.855a4.746,4.746,0,0,1-4.627,4.035,4.534,4.534,0,0,1-1.707-.334.814.814,0,0,1-.545.5.831.831,0,0,1-1-.567l-.432-1.55a.828.828,0,0,1,.639-1.049l1.519-.263a.816.816,0,0,1,.6,1.474,2.9,2.9,0,0,0,.924.153,3.12,3.12,0,0,0,3.019-2.676.815.815,0,1,1,1.608.274Z"
          transform="translate(-229.056 -249.807)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const ProfileIcon = () => {   
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28.871" height="30.435" viewBox="0 0 28.871 30.435">
      <path
        id="Path_15263"
        data-name="Path 15263"
        d="M30.954,24.1H29.9a5.271,5.271,0,0,0-.7-1.67l.743-.744a1.171,1.171,0,1,0-1.656-1.656l-.743.744a5.286,5.286,0,0,0-1.67-.7V19.028a1.171,1.171,0,1,0-2.341,0v1.049a5.286,5.286,0,0,0-1.67.7l-.743-.744a1.171,1.171,0,0,0-1.656,1.656l.743.744a5.286,5.286,0,0,0-.7,1.67H18.467a1.171,1.171,0,1,0,0,2.341h1.049a5.271,5.271,0,0,0,.7,1.67l-.743.744a1.17,1.17,0,1,0,1.654,1.656l.743-.744a5.286,5.286,0,0,0,1.67.7v1.049a1.171,1.171,0,1,0,2.341,0V30.466a5.286,5.286,0,0,0,1.67-.7l.743.744a1.17,1.17,0,1,0,1.654-1.656l-.743-.744a5.286,5.286,0,0,0,.7-1.67h1.049a1.171,1.171,0,0,0,0-2.341Zm-4.1,3.256c-.009.009-.022.011-.031.02a.352.352,0,0,0-.02.031,2.973,2.973,0,0,1-4.17,0,.353.353,0,0,1-.02-.031c-.008-.009-.022-.012-.031-.02a2.973,2.973,0,0,1,0-4.17c.009-.009.022-.011.031-.02a.353.353,0,0,0,.02-.031,2.973,2.973,0,0,1,4.17,0,.353.353,0,0,1,.02.031c.008.009.022.012.031.02a2.973,2.973,0,0,1,0,4.17ZM9.493,9.664a7.414,7.414,0,1,1,7.414,7.414A7.422,7.422,0,0,1,9.493,9.664ZM17.812,32.17a3.072,3.072,0,0,0,.671.515H7.542A4.29,4.29,0,0,1,3.25,28.393a8.986,8.986,0,0,1,8.974-8.974h4.87A3.55,3.55,0,0,0,17,22.072a3.534,3.534,0,0,0-2.045,3.2A3.5,3.5,0,0,0,17,28.455a3.663,3.663,0,0,0-.219,1.233,3.536,3.536,0,0,0,1.03,2.482Z"
        transform="translate(-3.25 -2.25)"
        fill="#333"
      />
    </svg>
  );
};
export const FeedbackSurveyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17.896" height="17.896" viewBox="0 0 17.896 17.896">
      <path
        id="Subtraction_18"
        data-name="Subtraction 18"
        d="M8.948,17.9H.671a.671.671,0,0,1-.49-1.126l1.943-2.09A8.825,8.825,0,0,1,0,8.948,8.948,8.948,0,1,1,8.948,17.9Zm0-4.81a.895.895,0,1,0,.9.895A.9.9,0,0,0,8.948,13.087Zm0-10.066a1.109,1.109,0,0,0-1.118,1.1c0,.526,1.107,7.335,1.118,7.4.009-.059,1.119-6.873,1.119-7.4A1.109,1.109,0,0,0,8.948,3.02Z"
        fill="white"
      />
    </svg>
  );
};

export const PrivacyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.961" height="30.304" viewBox="0 0 23.961 30.304">
      <path
        id="Privacy_Compliance"
        data-name="Privacy &amp; Compliance"
        d="M21685.98,5156.306h0a14.991,14.991,0,0,1-8.592-6.039,17.616,17.616,0,0,1-3.389-10.477v-9.241l11.98-4.547,11.98,4.547v9.241a17.673,17.673,0,0,1-3.387,10.477,14.994,14.994,0,0,1-8.594,6.039Zm-.021-10.76a1.5,1.5,0,0,0-1.105.474,1.584,1.584,0,0,0,0,2.238,1.527,1.527,0,0,0,2.211,0,1.57,1.57,0,0,0,0-2.238A1.506,1.506,0,0,0,21685.959,5145.546Zm0-9.769a2.245,2.245,0,0,1,1.443.49,1.541,1.541,0,0,1,.615,1.252,2.04,2.04,0,0,1-.393,1.193,7.179,7.179,0,0,1-.877,1c-.3.276-.6.562-.9.855a3.246,3.246,0,0,0-.713,1,2.479,2.479,0,0,0-.262,1.116v1.192h2.244v-.833a1.773,1.773,0,0,1,.189-.795,2.629,2.629,0,0,1,.6-.888l.139-.133c.219-.209.428-.408.646-.608a7.4,7.4,0,0,0,1.105-1.437,3.4,3.4,0,0,0,.467-1.743,3.483,3.483,0,0,0-1.289-2.788,4.588,4.588,0,0,0-3.018-1.078,4.382,4.382,0,0,0-2.674.872,4.241,4.241,0,0,0-1.59,2.309l2.02.833a2.691,2.691,0,0,1,.84-1.285A2.112,2.112,0,0,1,21685.959,5135.777Z"
        transform="translate(-21674 -5126.002)"
        fill="#333"
      />
    </svg>
  );
};

export const ConfigIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32.412" height="29" viewBox="0 0 32.412 29">
      <g id="Configurations" transform="translate(-5 -7)">
        <path
          id="Path_16462"
          data-name="Path 16462"
          d="M30.588,7H11.824a6.824,6.824,0,1,0,0,13.647H30.588A6.824,6.824,0,0,0,30.588,7Zm0,10.235A3.412,3.412,0,1,1,34,13.824,3.412,3.412,0,0,1,30.588,17.235Z"
          fill="#333"
        />
        <path
          id="Path_16463"
          data-name="Path 16463"
          d="M30.588,25H11.824a6.824,6.824,0,0,0,0,13.647H30.588a6.824,6.824,0,0,0,0-13.647ZM12.676,35.235a3.412,3.412,0,1,1,3.412-3.412A3.412,3.412,0,0,1,12.676,35.235Z"
          transform="translate(0 -2.647)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const OneView = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28.424" height="16.6" viewBox="0 0 28.424 16.6">
      <path
        id="One_View"
        data-name="One View"
        d="M23.979,10.747a10.751,10.751,0,0,0-12.62,0L3.4,17l7.959,6.253A10.068,10.068,0,0,0,17.612,25.3a10.068,10.068,0,0,0,6.253-2.047L31.824,17Zm-6.253,10.46A4.207,4.207,0,1,1,21.933,17,4.272,4.272,0,0,1,17.726,21.207Z"
        transform="translate(-3.4 -8.7)"
        fill="#333"
      />
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g id="Group_3141" data-name="Group 3141" transform="translate(-24.2 -24.2)">
        <path
          id="Path_14272"
          data-name="Path 14272"
          d="M29.781,48.2H42.619A5.6,5.6,0,0,0,48.2,42.619h0V38.991a.93.93,0,0,0-1.86,0v3.628a3.732,3.732,0,0,1-3.721,3.721H29.781a3.732,3.732,0,0,1-3.721-3.721V29.781a3.732,3.732,0,0,1,3.721-3.721h3.628a.93.93,0,0,0,0-1.86H29.781A5.6,5.6,0,0,0,24.2,29.781V42.619A5.6,5.6,0,0,0,29.781,48.2Z"
          fill="#333"
        />
        <path
          id="Path_14273"
          data-name="Path 14273"
          d="M50.482,25.677l-9.488,9.488a.9.9,0,0,0-.233.419l-1.3,4.651A.93.93,0,0,0,40.11,41.4a.951.951,0,0,0,.512,0l4.651-1.3a1.886,1.886,0,0,0,.419-.233l9.535-9.488a3.313,3.313,0,0,0,0-4.7,3.369,3.369,0,0,0-4.744,0ZM41.645,39.165l.465-1.581,1.163,1.163Zm12.186-10.14L45.04,37.816,42.994,35.77l8.791-8.791a1.462,1.462,0,0,1,2.047.14A1.478,1.478,0,0,1,53.831,29.026Z"
          transform="translate(-8.142 -0.267)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const DeleteIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-trash3"
      viewBox="0 0 16 16"
    >
      <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.531" height="23.966" viewBox="0 0 25.531 23.966">
      <g id="Group" transform="translate(-14.1 -16.3)">
        <path
          id="Compound_Path"
          data-name="Compound Path"
          d="M18.011,48H31.452a3.911,3.911,0,0,0,3.911-3.911V32.211A3.911,3.911,0,0,0,31.452,28.3H18.011A3.911,3.911,0,0,0,14.1,32.211V44.088A3.911,3.911,0,0,0,18.011,48ZM16.233,32.211a1.778,1.778,0,0,1,1.778-1.778H31.452a1.778,1.778,0,0,1,1.778,1.778V44.088a1.778,1.778,0,0,1-1.778,1.778H18.011a1.778,1.778,0,0,1-1.778-1.778Z"
          transform="translate(0 -7.733)"
          fill="#333"
        />
        <path
          id="Path"
          d="M48.395,34.328V20.923A4.623,4.623,0,0,0,43.772,16.3H28.767A1.1,1.1,0,0,0,27.7,17.367a1.067,1.067,0,0,0,1.067,1.067H43.772a2.489,2.489,0,0,1,2.489,2.489V34.328a1.067,1.067,0,0,0,1.067,1.067,1.031,1.031,0,0,0,1.067-1.067Z"
          transform="translate(-8.764)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const AssignIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.83" height="26.84" viewBox="0 0 24.83 26.84">
      <g id="Group_2899" data-name="Group 2899" transform="translate(1 1)">
        <path
          id="users-more_curved"
          d="M17.164,16.7a6.352,6.352,0,1,1,6.352-6.352A6.359,6.359,0,0,1,17.164,16.7Zm0-10.7a4.352,4.352,0,1,0,4.352,4.352A4.357,4.357,0,0,0,17.164,6Z"
          transform="translate(-8.806 -5)"
          fill="#333"
        />
        <path
          id="Path_14138"
          data-name="Path 14138"
          d="M-798.647-4755.292a1,1,0,0,1-1-.984c0-.038-.015-.966,0-3.1a6.812,6.812,0,0,1,2.215-4.811,9.176,9.176,0,0,1,6.543-2.362h.026a10.273,10.273,0,0,1,7.132,2.378,6.506,6.506,0,0,1,1.813,2.556l-1.9.631,0,.009a4.808,4.808,0,0,0-1.343-1.785,8.467,8.467,0,0,0-5.708-1.788h-.024a7.223,7.223,0,0,0-5.168,1.813,4.874,4.874,0,0,0-1.591,3.373c-.015,2.111,0,3.05,0,3.059a1,1,0,0,1-.984,1.016Z"
          transform="translate(798.653 4779.619)"
          fill="#333"
        />
        <path
          id="Path_14154_-_Outline"
          data-name="Path 14154 - Outline"
          d="M9.567,13.975a.786.786,0,0,1,.559.232l3.646,3.646a.962.962,0,0,1,.257.526l0,.023a.8.8,0,0,1-.235.56L10.138,22.62a.778.778,0,0,1-.56.235.8.8,0,0,1-.56-.235.753.753,0,0,1-.232-.54.784.784,0,0,1,.232-.568l2.3-2.314H3.134a.784.784,0,1,1,0-1.567h8.2L9.017,15.316a.753.753,0,0,1-.232-.54.784.784,0,0,1,.232-.568A.753.753,0,0,1,9.567,13.975Z"
          transform="translate(9.799 2.985)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23.51" height="23.043" viewBox="0 0 26.51 28.043">
      <path
        id="Settings"
        d="M28.071,18.381l-.65-.376a1.182,1.182,0,0,1-.587-1.129c.025-.281.04-.566.04-.853s-.015-.572-.04-.853a1.178,1.178,0,0,1,.587-1.129l.65-.376a2.408,2.408,0,0,0,.881-3.288l-1.576-2.73a2.408,2.408,0,0,0-3.288-.881l-.648.375a1.214,1.214,0,0,1-1.3-.073,10.679,10.679,0,0,0-1.475-.846A1.123,1.123,0,0,1,20,5.212v-.8A2.407,2.407,0,0,0,17.6,2H14.445a2.407,2.407,0,0,0-2.407,2.407v.749a1.215,1.215,0,0,1-.711,1.087A10.9,10.9,0,0,0,9.855,7.1a1.121,1.121,0,0,1-1.2.07L8.013,6.8a2.425,2.425,0,0,0-3.348.846l-1.576,2.73a2.407,2.407,0,0,0,.881,3.288l.65.376a1.182,1.182,0,0,1,.587,1.129c-.025.281-.04.566-.04.853s.015.573.04.853A1.178,1.178,0,0,1,4.62,18l-.65.376a2.408,2.408,0,0,0-.881,3.288L4.665,24.4a2.408,2.408,0,0,0,3.288.881L8.6,24.9a1.214,1.214,0,0,1,1.3.073,10.678,10.678,0,0,0,1.475.846,1.123,1.123,0,0,1,.663,1.009v.8a2.408,2.408,0,0,0,2.407,2.408H17.6A2.407,2.407,0,0,0,20,27.636v-.749a1.214,1.214,0,0,1,.711-1.087,10.846,10.846,0,0,0,1.471-.854,1.123,1.123,0,0,1,1.2-.07l.637.368a2.424,2.424,0,0,0,3.347-.846l1.576-2.729A2.4,2.4,0,0,0,28.071,18.381Zm-12.05,2.712a5.071,5.071,0,1,1,5.071-5.071A5.071,5.071,0,0,1,16.021,21.093Z"
        transform="translate(-2.765 -2)"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export const SearchesCIconData = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
      <g id="Search_icon" data-name="Search icon" transform="translate(0.001 0)" opacity="0.5">
        <path
          id="Ellipse_642"
          data-name="Ellipse 642"
          d="M9,1.5A7.5,7.5,0,1,0,16.5,9,7.508,7.508,0,0,0,9,1.5M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z"
          transform="translate(-0.001 0)"
          fill="#333"
        />
        <path
          id="Ellipse_643"
          data-name="Ellipse 643"
          d="M2.5,0A2.5,2.5,0,1,1,0,2.5,2.5,2.5,0,0,1,2.5,0Z"
          transform="translate(15.999 15)"
          fill="#333"
        />
      </g>
    </svg>
  );
};
export const SurveyIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v128zm96 0c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v224zm96 0c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64z" />
    </svg>
  );
};
export const CheckedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi-check-lg"
      viewBox="0 0 16 16"
    >
      <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#fff" className="bi bi-x" viewBox="0 0 16 16">
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const SelectAllIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-people"
      viewBox="0 0 16 16"
    >
      <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
    </svg>
  );
};

export const WarningIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-exclamation-diamond"
      viewBox="0 0 16 16"
    >
      <path d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z" />
      <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.297" height="19.35" viewBox="0 0 21.297 19.35">
      <g id="Group_4203" data-name="Group 4203" transform="translate(0 -1)">
        <path
          id="Path_15265"
          data-name="Path 15265"
          d="M17.51,12.814a3.768,3.768,0,1,1-3.79,3.768A3.782,3.782,0,0,1,17.51,12.814Zm0,1.825a1.942,1.942,0,1,0,1.962,1.942A1.956,1.956,0,0,0,17.51,14.64ZM8.616,15.717a.913.913,0,1,1,0,1.825H.948a.913.913,0,1,1,0-1.825ZM3.788,1A3.768,3.768,0,1,1,0,4.769,3.783,3.783,0,0,1,3.788,1Zm0,1.825A1.942,1.942,0,1,0,5.751,4.769,1.956,1.956,0,0,0,3.788,2.825ZM19.7,3.921a.913.913,0,0,1,0,1.825H12.037a.913.913,0,0,1,0-1.825Z"
          fill="#fff"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const HeartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi bi-suit-heart-fill"
      viewBox="0 0 16 16"
    >
      <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1" />
    </svg>
  );
};

export const BGGuys = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1028.627" height="561.158" viewBox="0 0 1028.627 561.158">
      <path
        id="Path_16360"
        data-name="Path 16360"
        d="M-23679.23-923.459h-315.621s-8.937.631-7.24-7.539c14.9-58.415,66.854-226.12,66.854-226.12s6.7-29.543-13.549-54.168-50.07-56.638-50.07-56.638-11.221-13.954,2.734-26.814,59.1-33.928,54.723-73.6-32.012-58.553-32.012-58.553-6.84-3.283-6.293,6.02-11.49,22.436-37.484,20.795-47.609-14.228-47.609-14.228a7.412,7.412,0,0,0-7.936,1.642c-3.557,3.557-13.133,10.124-13.133,10.124s-8.754,4.1-13.133-1.368-12.586-25.993-12.586-25.993-4.105-7.114,4.65-12.039,57.186-35.023,78.8-36.117c0,0,11.219,1.915,0,7.661s-63.752,28.456-63.752,28.456-13.682,7.387,0,5.746,39.127-13.133,39.127-13.133,16.689-6.84,24.625,9.85,11.766,24.9,21.068,18.606,16.689-17.238,16.689-17.238,2.461-6.293-3.01-15.049-18.332-32.286-21.342-26.54,21.342,41.589,21.342,41.589,12.041,31.739-23.8,29-37.213-3.557-37.213-3.557-7.115-2.736-18.332,7.661l-10.568,8.628s-5.748,5.077.574,7.664a61.483,61.483,0,0,1,8.717,4.119s8.336,7.76-2.969,11.975c-12.455.192-19.16,0-19.16,0s-5.91.766-2.859,5.173-3.846,11.975-3.846,11.975-15.2,21.842,3.846,30.273c19.721,3.257,46.861,3.223,79.9-20.56s27.99-22.1,28.623-24.625-6.734-33.255,20.838-33.255,26.729,67.141,11.785,66.3c-4-1.684-3.154-26.1-15.152-25.677s-28.414,2.526-26.73,25.677c1.053,8.629,13.891,4.841,13.891,4.841s16.627-10.1,14.943-19.995-14.943-2.1-14.943-2.1v8.84s-1.053,4-4.631,0-8.207,0-8.207,0-22.535,25.047-65.26,23.784c0,0-8.193-.211-13.041,5.051-8.426,1.684-15.791-6.1-16.424,15.154s-20.416,30.939-20.416,30.939-37.045,7.156-51.566,30.308-53.248,94.081-53.248,94.081-16.627,29.466-42.3,28.624-27.994,0-27.994,0-7.156-1.052-6.945,7.156a97.432,97.432,0,0,1-1.684,17.89s-3.578-37.253-37.674-23.152-30.52,25.257-30.52,25.257,63.564-13.891,93.451,17.68c-6.7,24.034-29.113,47.154-29.113,75.254,0,0-3.914,8.181-15.295,0s-32.012-20.63-32.012-20.63a9.521,9.521,0,0,1-3.912-7.825c0-5.335,1.064-14.939-7.115-18.141s-38.77-9.248-38.77-15.651,12.807-10.671,18.5-10.671,37.348-2.336,37.348-2.336,6.758-.865,0-4.778,5.691-8.537,5.691-8.537,48.266-7.825,64.682,26.322c-9.193,36.281-26.98,69.361-20.221,71.139s42.684-57.979,42.684-57.979,3.914-10.315-7.113-6.758,29.879,18.141,29.879,18.141,42.785,19.308,81.857,17.073,46.219-35.214,46.219-35.214,34.271-153.791,82.723-148.321,43.762,76.808,35.166,109.127-35.746,128.474-51.041,140.923-29.166,8.892-43.75,4.98-167.891-33.435-167.891-33.435-14.943,2.134-6.049-22.765,14.941-48.019,14.941-60.468-5.691-23.61-5.691-29.234,29.17-20.208,39.84-37.281,55.133-96.394,55.133-96.394,17.832-32.013,46.619-29.879,44.084,12.805,75.029-8.181-15.295,13.872-20.986,16.362-25.967,10.671-38.416,11.027-30.447,0-30.447,0-14.727,2.846-5.479,17.073,20.3,30.59,20.3,30.59,5.313,12.449-7.137,17.429-31.3,13.161-31.3,13.161-9.957,7.114-1.777,22.053,15.648,33.3-7.826,44.039-50.865,9.315-35.926,43.462,37.705,67.582-23.475,72.918-50.512,4.98-50.512,4.98-15.406-.711-15.35,22.409-2.078,25.255-14.527,24.9-421.023,0-421.023,0"
        transform="translate(24707.857 1482.592)"
        fill="none"
        stroke="#e8e8ff"
        strokeWidth="4"
      />
    </svg>
  );
};

export const SideNavIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16">
      <g id="menu-right-alt" transform="translate(0)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M4,6.522A1.511,1.511,0,0,1,5.5,5h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,6.522Z"
          transform="translate(-4 -5)"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M4,18.522A1.511,1.511,0,0,1,5.5,17h21a1.523,1.523,0,0,1,0,3.045H5.5A1.511,1.511,0,0,1,4,18.522Z"
          transform="translate(-4 -4.045)"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M11.523,11a1.522,1.522,0,0,0,0,3.045H23.7A1.522,1.522,0,0,0,23.7,11Z"
          transform="translate(-1.225 -4.523)"
        />
      </g>
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24.015" height="15.336" viewBox="0 0 24.015 15.336">
      <g id="Group_5530" data-name="Group 5530" transform="translate(-6.075 -22)">
        <path
          id="Path_16648"
          data-name="Path 16648"
          d="M25.791,25.007A12.757,12.757,0,0,0,18.082,22a12.757,12.757,0,0,0-7.709,3.007A24.009,24.009,0,0,0,6.3,29.025a1.028,1.028,0,0,0,0,1.285,25.145,25.145,0,0,0,4.073,4.018,12.881,12.881,0,0,0,7.709,3.007,12.819,12.819,0,0,0,7.709-3.007,24.009,24.009,0,0,0,4.073-4.018,1.028,1.028,0,0,0,0-1.285A22.056,22.056,0,0,0,25.791,25.007ZM18.082,35.215c-5.358,0-9.561-4.385-10.491-5.561.957-1.175,5.133-5.561,10.491-5.561s9.51,4.385,10.439,5.561C27.592,30.83,23.44,35.215,18.082,35.215Z"
          fill="#333"
        />
        <path
          id="Path_16649"
          data-name="Path 16649"
          d="M36.921,32a4.921,4.921,0,1,0,4.921,4.921A4.935,4.935,0,0,0,36.921,32Zm0,8.748a3.827,3.827,0,1,1,3.827-3.827A3.838,3.838,0,0,1,36.921,40.748Z"
          transform="translate(-18.838 -7.266)"
          fill="#333"
        />
        <path
          id="Path_16650"
          data-name="Path 16650"
          d="M40.9,43.388h1.093a1.4,1.4,0,0,1,1.394-1.394V40.9A2.5,2.5,0,0,0,40.9,43.388Z"
          transform="translate(-25.305 -13.733)"
          fill="#333"
        />
      </g>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      className="bi-plus-lg"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
      />
    </svg>
  );
};
export const TotalFeedbackResponses = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 11.5C21 16.1944 16.9706 20 12 20H7L3 23V5C3 3.89543 3.89543 3 5 3H12C16.9706 3 21 6.80558 21 11.5Z"
        fill="white"
      />
      <rect x="7" y="8" width="10" height="1.5" fill="black" />
      <rect x="7" y="12" width="7" height="1.5" fill="black" />
    </svg>
  );
};
export const TotalSurveyResponses = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="3" width="16" height="18" rx="2" ry="2" fill="white" />
      <rect x="8" y="6.5" width="8" height="1.5" fill="black" />
      <rect x="8" y="10.5" width="8" height="1.5" fill="black" />
      <rect x="8" y="14.5" width="4" height="1.5" fill="black" />
    </svg>
  );
};
